<template>
  <b-modal v-model="isModalActive" :id="'sideBar' + $store.state.sidebar" :can-cancel="false">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <div class="form-modal-title">
          <h1>{{ type == 'invitation' ? `Genelate Invitation` : `Genelate tickets` }}</h1>
        </div>
      </div>

      <div class="form-modal-body">
        <b-field :label="type == 'invitation' ? `Invitations Number` : 'Tickets number'">
          <b-input v-model="form.ticket_number" type="number" placeholder="How many?" icon-pack="fas" icon="ticket-alt"
            expanded></b-input>
        </b-field>
        <b-field label="Seat type">
          <b-select v-model="form.priceId" icon-pack="fas" icon="wheelchair" placeholder="Select Seat"
            :loading="loadingSeatType" expanded>
            <option v-for="(item, index) in pricing_data" :value="item.id" :key="index">{{ item.name }}
              ({{ item.type == 'subevents' ? getSubEventLabel(item) : `Whole Event` }})</option>
          </b-select>
        </b-field>

        <b-field v-if="event.seasonEnabled" label="Select Season">
          <b-select placeholder="Select season" v-model="form.seasonCount">
            <option v-for="season in event.seasonCount" :value="season" :key="season">
              Season {{ season }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="form-modal-footer">
        <b-button :loading="submit_loading" @click="submitForm()" type="is-primary">
          SUBMIT
        </b-button>
        <b-button @click="onCancel" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { getSubEventLabel } from "@/helpers/subEvent.js";

export default {
  components: {},
  props: {
    event: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: null,
    }
  },
  data: () => ({
    isModalActive: true,
    form: {
      event_id: null,
      ticket_number: null,
      priceId: null,
      ticketType: "invitation",
      seasonCount: 1,
    },
    submit_loading: false,
    pricing_data: [],
    loadingSeatType: false
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getAllPrice();
  },
  beforeDestroy() {
    let vm = this;
  },
  methods: {
    getSubEventLabel,
    getAllPrice() {
      let vm = this;
      vm.$store
        .dispatch("PRICING_GET_PRICING", {
          type: "events",
          ref_id: vm.event.id,
        })
        .then((response) => {
          vm.pricing_data = response.data.return.sort((a, b) =>
            a.item_index > b.item_index ? 1 : -1
          );
        })
        .catch(({ response }) => { });
    },
    submitForm() {
      let vm = this;
      const rules = {
        ticket_number: {
          run: (value) => {
            if (!value) {
              return "Ticket Number is required";
            }
            return false;
          },
        },
        priceId: {
          run: (value) => {
            if (!value) {
              return "Seat Type is required";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.submit_loading = true;
        vm.form.event_id = vm.event.id;
        vm.form.ticketType = vm.type;
        vm.$store
          .dispatch("ADMIN_USER_GENERATE_EVENT_TICKETS", vm.form)
          .then((response) => {
            vm.submit_loading = false;
            vm.$emit("saved", response.data.return);
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.submit_loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      }

    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.form-modal-widget {
  width: 400px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  @media (max-width: 628px) {
    width: 95% !important;

    .row {
      flex-direction: column;
    }
  }

  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 100px;
    padding-bottom: 30px;
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}

#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 846px) {
      width: 500px;
    }

    @media (max-width: 768px) {
      width: 600px;
    }
  }
}
</style>